module.exports = __webpack_public_path__ + "static/media/jumbotronRepresentative.50fb3388.jpg";